import { disabledProps } from './disabled'
import { focusProps } from './focus'

export const fieldTheme = {
	bg: 'white',
	borderRadius: 'base',
	borderColor: 'gray.300',
	_disabled: disabledProps,
	_hover: {
		borderColor: 'gray.400',
		// zIndex: 1,
	},
	_focus: focusProps,
	_invalid: { boxShadow: 'none' },
}

const sizes = {
	md: {
		field: {
			px: 3,
		},
	},
}

export const inputTheme = {
	defaultProps: {
		field: {},
	},
	sizes,
	variants: {
		outline: {
			field: fieldTheme,
		},
	},
}
